/**
 * Canonical timeline defaults shared across layers.
 * Tuned for a denser 1080p editor layout.
 */
import { EDITOR_LAYOUT } from '@/shared/ui/editor-layout';

export const DEFAULT_TRACK_HEIGHT = EDITOR_LAYOUT.timelineTrackHeight;
export const DEFAULT_FPS = 30;
